import { LiveChatState } from '.';

const initialState: LiveChatState = {
  agentIcon: undefined,
  agentName: 'Live Support Agent',
  agentTyping: false,
  chatId: '',
  integration: undefined,
  integrationConfig: {
    integrationId: '',
  },
  isEndLiveChatModalVisible: false,
  isInAssistantMode: false,
  jwt: '',
  liveChatQuery: '',
  queuePosition: undefined,
  status: undefined,
  submitted_csat_result: {},
  userEndedChat: false,
};

export default initialState;
